import { render } from "./InputReference.vue?vue&type=template&id=3073c1c9&scoped=true"
import script from "./InputReference.vue?vue&type=script&lang=ts"
export * from "./InputReference.vue?vue&type=script&lang=ts"

import "./InputReference.vue?vue&type=style&index=0&id=3073c1c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3073c1c9"

export default script